const selectorsSidebar = {
  ANCHOR_SELECTOR: ".js-anchor-item",
  ANCHOR_SECTINO_SELECTOR: ".js-anchor-section",
  ACTIVE_CLASS: "active"
};

class WarrantySidebar extends HTMLElement {
  constructor() {
    super();

    this.anchorEls = this.querySelectorAll(selectorsSidebar.ANCHOR_SELECTOR)
    this.anchorSectionEls = document.querySelectorAll(selectorsSidebar.ANCHOR_SECTINO_SELECTOR)
    this.handleScroll = this.throttle(this.updateActiveAnchor.bind(this), 100);
    this.isScrollingFromClick = false;
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    if (this.anchorEls.length) {
      window.addEventListener('scroll', this.handleScroll);
      
      this.anchorEls.forEach((anchor) => {
        anchor.addEventListener('click', () => {
          const { position } = anchor.dataset
          const sectionEl = this.anchorSectionEls.length ? this.anchorSectionEls[position] : undefined
          this.removeClassActive(this.anchorEls, selectorsSidebar.ACTIVE_CLASS)
          anchor.classList.add(selectorsSidebar.ACTIVE_CLASS)

          if (sectionEl) {
            this.isScrollingFromClick = true;
            const headerOffset = 100;
            const elementPosition = sectionEl.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });

            setTimeout(() => {
              this.isScrollingFromClick = false;
            }, 1000);
          }
        })
      });
    }
  }

  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  updateActiveAnchor() {
    if (this.isScrollingFromClick) return;

    const headerOffset = 100;
    const viewportTop = window.scrollY + headerOffset;
    const viewportBottom = viewportTop + window.innerHeight;

    // Find the section that's currently at the top of the viewport
    let activeIndex = -1;
    this.anchorSectionEls.forEach((section, index) => {
      const sectionRect = section.getBoundingClientRect();
      const sectionTop = sectionRect.top + window.pageYOffset;
      
      // Check if the section's top is near the viewport top (within headerOffset)
      if (Math.abs(viewportTop - sectionTop) < headerOffset) {
        activeIndex = index;
      }
      // If no section is at the top, check if the next section hasn't appeared yet
      else if (activeIndex === -1 && sectionTop > viewportTop) {
        activeIndex = Math.max(0, index - 1);
      }
    });

    // Update active anchor
    if (activeIndex >= 0) {
      this.removeClassActive(this.anchorEls, selectorsSidebar.ACTIVE_CLASS);
      this.anchorEls[activeIndex]?.classList.add(selectorsSidebar.ACTIVE_CLASS);
    }
  }

  removeClassActive(items, classActive) {
    if (!items.length) return

    items.forEach((item) => {
      item.classList.remove(classActive)
    });
  }
}

if (!customElements.get("warranty-sidebar")) {
  customElements.define("warranty-sidebar", WarrantySidebar);
}
